import React from 'react';
import { useImpersonation } from '../contexts/ImpersonationContext';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonatedUser, impersonatingAdmin, expiresAt, endImpersonation } = useImpersonation();

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  const handleExitImpersonation = () => {
    endImpersonation();
    // Close the tab since this was opened by admin
    window.close();
    // If window.close() doesn't work (browser restriction), redirect to a neutral page
    setTimeout(() => {
      window.location.href = '/';
    }, 100);
  };

  // Calculate time remaining
  const getTimeRemaining = () => {
    if (!expiresAt) return '';
    const now = new Date();
    const expires = new Date(expiresAt);
    const diffMs = expires.getTime() - now.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    if (diffMins <= 0) return 'Session expired';
    if (diffMins === 1) return '1 minute remaining';
    return `${diffMins} minutes remaining`;
  };

  return (
    <div className="bg-orange-500 text-white px-4 py-2 flex items-center justify-between shadow-lg z-50">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <span className="font-semibold">Admin View</span>
        </div>
        <div className="text-sm">
          Viewing as: <span className="font-bold">{impersonatedUser.name || impersonatedUser.email}</span>
        </div>
        <div className="text-sm text-orange-100 hidden sm:block">
          ({getTimeRemaining()})
        </div>
      </div>
      <div className="flex items-center gap-4">
        <span className="text-sm text-orange-100 hidden md:block">
          Logged in by: {impersonatingAdmin?.name || impersonatingAdmin?.email}
        </span>
        <button
          onClick={handleExitImpersonation}
          className="bg-orange-700 hover:bg-orange-800 px-3 py-1 rounded text-sm font-medium transition-colors"
        >
          Exit Impersonation
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
